module.exports = __webpack_public_path__ + "static/media/th-large.0eafdbc7.svg";